interface MatrixQuestionProps {
  rows: string[];
  columns: string[];
  value: Record<string, string> | undefined;
  onChange: (value: Record<string, string>) => void;
  missing?: boolean;
}

const SHORT_COLS = ['Excelente', 'Aceptable', 'Inadecuada', 'Sin contacto'];

// Matriz de áreas (q30): una tarjeta por área; colapsa a 2 columnas en móvil
// (regla en styles.css). Cada fila es un radiogroup (handoff §8, §10).
export function MatrixQuestion({ rows, columns, value, onChange, missing }: MatrixQuestionProps) {
  const val = value ?? {};
  return (
    <div className="gb-matrix">
      {rows.map((row) => {
        const isMissing = missing && !val[row];
        return (
          <div key={row} className={'gb-matrix__row' + (isMissing ? ' is-missing' : '')}>
            <p className="gb-matrix__area">{row}</p>
            <div className="gb-matrix__choices" role="radiogroup" aria-label={row}>
              {columns.map((col, ci) => {
                const selected = val[row] === col;
                return (
                  <button
                    key={col}
                    type="button"
                    role="radio"
                    aria-checked={selected}
                    aria-label={`${row}: ${col}`}
                    className={
                      'gb-matrix__choice' +
                      (selected ? ' is-selected' : '') +
                      (ci === 3 ? ' gb-matrix__choice--na' : '')
                    }
                    onClick={() => onChange({ ...val, [row]: col })}
                    title={col}
                  >
                    {selected ? <span aria-hidden="true">✓ </span> : null}
                    {SHORT_COLS[ci] ?? col}
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
